import styled from 'styled-components';
import { Columns } from '@components/Columns';
import { Box } from '@components/Box';
import { themeMediaQuery } from '@utils/styledTheme.util';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { defaultBase64Placeholder } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import { CloudImage } from '@components/CloudImage';

export const BoxSection = styled(Box)`
  position: relative;
  height: 100%;
  width: 100%;
`;

export const BackgroundImageContainer = styled(Box)<{ isScrolledIntoView: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-image: url(${({ isScrolledIntoView }) =>
    isScrolledIntoView
      ? cloudAssetUrl('wedding-invitations/flexible-rsvp-questions/intro-bg.jpg', { mobileResizeWidth: 1500, optimization: 'mild' })
      : defaultBase64Placeholder});
  background-position: bottom;
  background-size: cover;
  z-index: -1;

  ${themeMediaQuery('below_sm')} {
    background-position: top left 44%;
  }
`;

export const FlexColumns = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    display: flex;
    flex-direction: column;
  }
`;

export const StyledColumn = styled(Columns.Column)<{
  order?: number;
}>`
  ${themeMediaQuery('below_sm')} {
    order: ${(props) => (props.order ? props.order : 'initial')};
  }
`;

export const MainTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 800px;
    ${themeMediaQuery('xl')} {
      max-width: 950px;
    }
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 330px;
    ${themeMediaQuery('xl')} {
      max-width: 430px;
    }
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  width: 520px;
  ${themeMediaQuery('sm')} {
    width: 100%;
  }
  ${themeMediaQuery('md')} {
    width: 520px;
  }
`;
